"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgDefaults = void 0;
exports.SvgDefaults = {
    viewBoxWidth: 200,
    strokeWidth: 0,
    fillColor: '#000000',
    strokeColor: '#000000',
};
//# sourceMappingURL=constants.js.map